import React, { useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";

import Buttons from "../../components/ui/button/Buttons";
import { CommitteeApprovalData, CreateGMPCourseData, StaffApprovalData } from "./data/CreateGMPCourse.Data";
import { useEffect } from "react";
import { useCommitteDecisionApproveOrRejectMutation, useLazyGetCourseProviderByMemberIdQuery, useLazyInternalNotesStaffAndCommitteeQuery, useStaffDecisionApproveOrRejectMutation, useUpdateGmpCourseProviderMutation } from "../../app/services/GMPCourseProvider/GMPCoursePoviderApi";
import { setAllDropDownField, setFieldParameter, setFieldParameterForStaffCommittee } from "./utils/setFieldParameter";
import { useNavigate, useParams } from "react-router-dom";
import { decryptAESID } from "../../utils/Encryption";
import { useLazyGetAllDropDownsForMemberDirectoryQuery, useStoreBase64ImageMutation } from "../../app/services/common/commonApi";
import CenterModel from "../../components/ui/centerModel/CenterModel";
import { APIUrl } from "../../utils/API/fetchBaseQuery";
import SwalAlert from "../../services/swalService/SwalService";
import { useRef } from "react";
import ToastService from "../../services/toastService/ToastService";
import Swal from "sweetalert2";

const EditGMPCourseTaskList = () =>
{
  const courseProviderRef = useRef();
  const staffApprovalRef = useRef();
  const committeeDecisionRef = useRef();
  const navigate = useNavigate();
  const { id } = useParams();
  const editID = id ? decryptAESID( id, false ) : 0
  const [ formData, setFromData ] = useState( CreateGMPCourseData );
  const [ commiteeFormData, setCommitteeFromData ] = useState( CommitteeApprovalData );
  const [ staffFormData, setStaffFromData ] = useState( StaffApprovalData );
  const [ isModalOpen, setIsModalOpen ] = useState( false );
  const { success, error } = SwalAlert();
  const [ organisationLogo, setOrganisationLogo ] = useState( null );

  const [ getCourseProviderByMemberId, { isSuccess: isSuccess, isFetching: isFetching, data: getCourseProviderMemberResponse }, ] = useLazyGetCourseProviderByMemberIdQuery();
  const [ getAllDropDowns, { isSuccess: isGetAllDropDownFetched, isFetching: isGetDropDownFetching, data: allDropDownResponse }, ] = useLazyGetAllDropDownsForMemberDirectoryQuery();
  const [ updateGmpCourseProvider, { isSuccess: isSuccessUpdate, isLoading: isFetchingAppUpdate, data: updateGmpCourseProvidertResponse }, ] = useUpdateGmpCourseProviderMutation();
  const [ saveMainImage, { isSuccess: isSuccessImage, isLoading: isLoadingImage, data: profileImageUpload } ] = useStoreBase64ImageMutation();
  const [ staffDecisionApproveOrReject, { isSuccess: isSuccessStaffDecisionApproveOrReject, isLoading: isFetchingAppStaffDecisionApproveOrReject, data: StaffDecisionApproveOrRejectResponse }, ] = useStaffDecisionApproveOrRejectMutation();
  const [ internalNotesStaffAndCommittee, { isSuccess: internalNotesStaffAndCommitteeisSuccess, isLoading: internalNotesStaffAndCommitteeisisLoading, data: internalNotesStaffAndCommitteeResponse }, ] = useLazyInternalNotesStaffAndCommitteeQuery();
  const [ committeDecisionApproveOrReject, { isSuccess: isSuccessCommitteDecisionApproveOrReject, isLoading: isFetchingAppCommitteDecisionApproveOrReject, data: CommitteDecisionApproveOrRejectResponse }, ] = useCommitteDecisionApproveOrRejectMutation();

  useEffect( () =>
  {
    const fetchData = async () =>
    {
      await getAllDropDowns();
      if ( id )
      {
        getCourseProviderByMemberId( editID );
        internalNotesStaffAndCommittee( editID );
      }
    };
    fetchData();
  }, [ editID ] );

  useEffect( () =>
  {

    if ( !isFetching && isSuccess && getCourseProviderMemberResponse )
    {
      setFieldParameter( getCourseProviderMemberResponse, "getCourseProviderMemberResponse" );
      const getUpdatedFormFields = ( formData ) =>
      {
        return formData.map( field => ( {
          ...field,
          fieldSetting: {
            ...field.fieldSetting,
            isDisable: getCourseProviderMemberResponse?.courseProviderStatusId === 5 || field.fieldSetting?.isDisable || false,
          },
        } ) );
      };
      const courseProviderFormFields = getUpdatedFormFields( CreateGMPCourseData.formFields );
      const staffFormFields = getUpdatedFormFields( StaffApprovalData.formFields );
      const committeeFormFields = getUpdatedFormFields( CommitteeApprovalData.formFields );
      setFromData( { ...CreateGMPCourseData, formFields: courseProviderFormFields } );
      setStaffFromData( { ...StaffApprovalData, formFields: staffFormFields } );
      setCommitteeFromData( { ...CommitteeApprovalData, formFields: committeeFormFields } );

    }
  }, [ isFetching, isSuccess, getCourseProviderMemberResponse ] );


  useEffect( () =>
  {
    if ( !isGetDropDownFetching && isGetAllDropDownFetched && allDropDownResponse )
    {
      setAllDropDownField( allDropDownResponse );
    }
  }, [ isGetDropDownFetching, isGetAllDropDownFetched, allDropDownResponse ] );

  useEffect( () =>
  {
    if ( !isFetchingAppUpdate && isSuccessUpdate && updateGmpCourseProvidertResponse )
    {
      success( "GMP Course Provider Updated Successfully " )
      getCourseProviderByMemberId( editID );
    }
  }, [ isFetchingAppUpdate, isSuccessUpdate, updateGmpCourseProvidertResponse ] );

  useEffect( () =>
  {
    if ( !isLoadingImage && isSuccessImage && profileImageUpload )
    {
      ToastService.success( "Image uploaded successfully !" )
    }
  }, [ isLoadingImage, isSuccessImage, profileImageUpload, ] );

  useEffect( () =>
  {
    if ( !isFetchingAppStaffDecisionApproveOrReject && isSuccessStaffDecisionApproveOrReject && StaffDecisionApproveOrRejectResponse )
    {
      if ( StaffDecisionApproveOrRejectResponse.errorMessage == "Approved" )
      {
        success( "Application Approved Successfully" )
      }
      else if ( StaffDecisionApproveOrRejectResponse.errorMessage == "Course Provider Already Reject Or Approved" )
      {
        error( "Course Provider Already Reject Or Approved" )
      }
      else
      {
        error( "Your Application has been rejected" );
      }
      setTimeout( () =>
      {
        navigate( '/gmpTaskList' );
      }, 2000 );
    }
  }, [ isFetchingAppStaffDecisionApproveOrReject, isSuccessStaffDecisionApproveOrReject, StaffDecisionApproveOrRejectResponse ] );

  useEffect( () =>
  {
    if ( !internalNotesStaffAndCommitteeisisLoading && internalNotesStaffAndCommitteeisSuccess && internalNotesStaffAndCommitteeResponse )
    {
      setFieldParameterForStaffCommittee( internalNotesStaffAndCommitteeResponse, "internalNotesStaffAndCommitteeResponse" );
    }
  }, [ internalNotesStaffAndCommitteeisisLoading, internalNotesStaffAndCommitteeisSuccess, internalNotesStaffAndCommitteeResponse ] );

  useEffect( () =>
  {
    if ( !isFetchingAppCommitteDecisionApproveOrReject && isSuccessCommitteDecisionApproveOrReject && CommitteDecisionApproveOrRejectResponse )
    {
      if ( CommitteDecisionApproveOrRejectResponse.errorMessage == "Approved" )
      {
        success( "Application Approved Successfully" )
      }
      else
      {
        error( "Your Application has been rejected" );
      }
      setTimeout( () =>
      {
        navigate( '/gmpTaskList' );
      }, 2000 );
    }
  }, [ isFetchingAppCommitteDecisionApproveOrReject, isSuccessCommitteDecisionApproveOrReject, CommitteDecisionApproveOrRejectResponse ] );

  const handleSubmit = () =>
  {
    let gmpCourseProviderData = courseProviderRef.current.getFormData();

    if ( !gmpCourseProviderData )
    {
      error( "Please fill all mandatory fields.", "" )
      return;
    }

    let request = {
      GMPCourseProviderId: editID,
      IsGovt: gmpCourseProviderData?.organizationfalls === "yes" ? true : false || false,
      OrganisationName: gmpCourseProviderData?.organisationName || null,
      UENNumber: gmpCourseProviderData?.UENNumber || null,
      MailingAddressLine1: gmpCourseProviderData?.mailingAddress1 || null,
      MailingAddressLine2: gmpCourseProviderData?.mailingAddress2 || null,
      CountryId: gmpCourseProviderData?.country?.value || gmpCourseProviderData?.country || null,
      PostalCode: gmpCourseProviderData?.postalCode | null,
      OrganisationWebsite: gmpCourseProviderData?.organisationWebsite || null,
      OrganisationLogo: profileImageUpload?.fileName || getCourseProviderMemberResponse.organisationLogo || null,
      OrganisationLogoName: profileImageUpload?.uploadedFileName || getCourseProviderMemberResponse?.organisationLogoName || null,
      DescriptionOfOrganisation: gmpCourseProviderData?.shortDescriptionofOrganisation || null,
      NameOfRepresentative: gmpCourseProviderData?.nameofRepresentative || null,
      EmailAddress: gmpCourseProviderData?.emailAddress || null,
      ContactNumber: gmpCourseProviderData?.contactNumber || null,
      AlternateNameOfRepresentative: gmpCourseProviderData?.alternateNameOfRepresentative || null,
      AlternateEmailAddress: gmpCourseProviderData?.alternateEmailAddress || null,
      AlternateContactNumber: gmpCourseProviderData?.alternateContactNumber || null
    }
    updateGmpCourseProvider( request );
  }

  const openModal = () =>
  {
    setIsModalOpen( !isModalOpen );
  }

  const handleViewImage = () =>
  {
    setIsModalOpen( true );
  }

  const handleOrganazationImageUpload = async ( data ) =>
  {
    const { base64Data, fileName: incomingFileName, name } = data;
    const fileName = incomingFileName || name;

    if ( !fileName )
    {
      error( "No file name provided", "File Upload Error" );
      return;
    }
    const fileExtension = fileName.split( '.' ).pop().toLowerCase();
    if ( fileExtension !== "jpg" && fileExtension !== "png" && fileExtension !== "jpeg" )
    {
      error( "Only Image files are allowed", "File Upload Error" );
      return;
    }

    let saveFileRequest = {
      fileName: fileName,
      fileStr: base64Data,
      storagePath: "GmpCourseProviderLogo",
    }
    const response = await saveMainImage( saveFileRequest )
    setOrganisationLogo( response.data.fileName );
  }

  const handleFormFieldChange = ( fieldName, value ) =>
  {
    if ( fieldName === "organisationLogo" && value )
    {
      handleOrganazationImageUpload( value );
    }

    setStaffFromData( ( prevData ) => ( {
      ...prevData,
      [ fieldName ]: value,
    } ) );
  };

  const handleApprove = () =>
  {
    let staffApprovalrData = staffApprovalRef.current.getFormData();

    let request = {
      CourseProviderId: editID,
      InternalComment: staffApprovalrData?.internalComments || null,
      IsSendforCommitteeApproval: staffApprovalrData?.sendforCommitteeApproval ? true : false,
      IsReject: false,
    };
    if ( !staffApprovalrData?.sendforCommitteeApproval )
    {
      Swal.fire( {
        title: "Are you sure?",
        text: "You want to approve without sending for committee approval?",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#11521c8b",
        cancelButtonColor: "#d33",
        confirmButtonText: "Yes",
        cancelButtonText: "No",
      } ).then( ( result ) =>
      {
        if ( result.isConfirmed )
        {
          staffDecisionApproveOrReject( request );
        }
      } );
    } else
    {
      staffDecisionApproveOrReject( request );
    }
  };


  const handleReject = () =>
  {
    let staffApprovalrData = staffApprovalRef.current.getFormData();
    let request = {
      CourseProviderId: editID,
      InternalComment: staffApprovalrData?.internalComments || null,
      IsSendforCommitteeApproval: staffApprovalrData?.sendforCommitteeApproval ? true : false,
      IsReject: true,
    }
    staffDecisionApproveOrReject( request );
    // handleSubmit();
  }

  const handleCommitteApprove = () =>
  {
    let commiteeFormData = committeeDecisionRef.current.getFormData();
    let request = {
      CourseProviderId: editID,
      InternalComment: commiteeFormData?.internalComments || null,
      IsReject: false,
    }
    committeDecisionApproveOrReject( request );
  }

  const handleCommitteReject = () =>
  {
    let commiteeFormData = committeeDecisionRef.current.getFormData();
    let request = {
      CourseProviderId: editID,
      InternalComment: commiteeFormData?.internalComments || null,
      IsReject: true,
    }
    committeDecisionApproveOrReject( request );
  }

  const handleBack = () =>
  {
    navigate( '/gmpTaskList' )
  }
  const formActionHandler = {
    VIEW_IMAGE: handleViewImage,
  }

  return (
    <>
      <div className="row form-card">
        { !isGetDropDownFetching &&
          <FormCreator
            ref={ courseProviderRef }
            { ...formData }
            onFormFieldValueChange={ handleFormFieldChange }
            onActionChange={ formActionHandler }
          />
        }
      </div>
      { isModalOpen &&
        <CenterModel
          modelTitle={ 'View Image' }
          show={ "test" }
          handleClose={ openModal }
          onUpload={ openModal }

        >
          <div className="image-model">
            <img
              src={ `${ APIUrl }/Common/getImage?type=GmpCourseProviderLogo&fileName=${ organisationLogo || getCourseProviderMemberResponse.organisationLogo }` }
              alt="Uploaded Image"
            />
          </div>
        </CenterModel >
      }
      <div className="col-md-12 mb-4 mt-4 d-flex justify-content-end">
        <Buttons
          buttonText={ "Save" }
          buttonTypeClassName="btn success-btn ml-2 mt-0"
          onClick={ handleSubmit }
        />
      </div>
      <div>
        <div className="row form-card-active">
          <div className="col-12">
            <FormCreator
              ref={ staffApprovalRef }
              { ...staffFormData }
              onFormFieldValueChange={ handleFormFieldChange }
            // onActionChange={formActionHandler}
            />
          </div>
          <div className="col-md-12 mb-0 mt-0 d-flex justify-content-between">
            <Buttons
              isDisable={ internalNotesStaffAndCommitteeResponse?.sentForCommitteeApproval === true || getCourseProviderMemberResponse?.courseProviderStatusId === 5 ? true : false }
              buttonText={ "Reject" }
              buttonTypeClassName="btn red-btn  ml-2 mt-0"
              onClick={ handleReject }
            />
            <Buttons
              isDisable={ internalNotesStaffAndCommitteeResponse?.sentForCommitteeApproval === true || isFetchingAppStaffDecisionApproveOrReject || getCourseProviderMemberResponse?.courseProviderStatusId === 5 ? true : false }
              buttonText="Approve"
              buttonTypeClassName='btn success-btn ml-2 mt-0'
              onClick={ handleApprove }
              isLoading={ isFetchingAppStaffDecisionApproveOrReject }
            />
          </div>
        </div>
        <div className="row form-card-active">
          <div className="col-12">
            <FormCreator ref={ committeeDecisionRef } { ...commiteeFormData } />
          </div>
          <div className="col-md-12 mb-0 mt-0 d-flex justify-content-between">
            <Buttons
              isDisable={ getCourseProviderMemberResponse?.courseProviderStatusId === 5 ? true : false }
              buttonText={ "Reject" }
              buttonTypeClassName="btn red-btn ml-2 mt-0"
              onClick={ handleCommitteReject }
            />
            <Buttons
              isDisable={ isFetchingAppCommitteDecisionApproveOrReject || getCourseProviderMemberResponse?.courseProviderStatusId === 5 ? true : false }
              buttonText={ "Approve" }
              buttonTypeClassName="btn success-btn ml-2 mt-0"
              onClick={ handleCommitteApprove }
              isLoading={ isFetchingAppCommitteDecisionApproveOrReject }
            />
          </div>
        </div>
      </div>
      <div className="col-md-12 mb-4 mt-4 d-flex justify-content-start">
        <Buttons
          buttonText={ "Back" }
          buttonTypeClassName="btn black-btn ml-2 mt-0"
          onClick={ handleBack }
        />
      </div>
    </>
  );
};

export default EditGMPCourseTaskList;
